export const clientWidthIsSmallMixin = {
    data() {
        return {
            clientWidthIsSmall: this.handleResize(),
        };
    },
    methods: {
        handleResize() {
            this.clientWidthIsSmall = document.documentElement.clientWidth < 544;
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
};



// WEBPACK FOOTER //
// ./src/assets/js/mixins.js